/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchContainersDictionaryResponse } from './search-containers-dictionary-response';


export interface SearchContainersDictionaryResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchContainersDictionaryResponse> | null;
}

